export default __webpack_public_path__ + "static/media/172047615_3903993176343210_6566616350470094068_n.beb3ac33.png";